import BaseActionButton from "@components/controls/buttons/BaseActionButton";
import {useTranslation} from "react-i18next";
import {VivoPortal} from "@utils/AppConstants";
import {FlintActionButtonProps} from "@components/controls/buttons/FlintActionButtonProps";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;

export default function FlintButton_Save(props:FlintActionButtonProps) {
    const {t} = useTranslation();
    const {buttonText = t("Save"), themeColor = "primary", ...other} = props;
    return <BaseActionButton iconEnum={EnumIconButtonDefaultType.Save} themeColor={themeColor} {...other}>
        {buttonText}
    </BaseActionButton>
}

